import React from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '../../../../core/ui';
import { useTranslation } from '../../../../core/context/TranslationContext';
import { formatShortDate } from '../../../../core/format/date';

import styles from './CardChargeNote.module.css';

const formatTry = (amount) =>
  new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(Number(amount || 0));

/** Shows the card statement line a receipt is bound to, with a link to that statement. */
export default function CardChargeNote({ link }) {
  const { t, language } = useTranslation();
  if (!link) return null;

  return (
    <div className={styles.note}>
      <Icon name="fa-credit-card" size="sm" className={styles.icon} />
      <div className={styles.body}>
        <div className={styles.title}>{t('receipts.paidByCard')}</div>
        <div className={styles.meta}>
          {link.merchant} · {formatShortDate(link.transactionDate, language)} · {formatTry(link.amount)}
        </div>
        <Link to={`/budget/statements/${link.statementId}`} className={styles.link}>
          {t('receipts.viewStatement')} →
        </Link>
      </div>
    </div>
  );
}
